import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DashboardOrder } from '../../entities/dashboard';

interface CommercialOffersState {
  data: {
    commercialOffersFound: boolean,
    existingEcoOffers: boolean,
    existingCexOffers: boolean,
    existingCbrOffers: boolean,
    existingSusOffers: boolean,
    existingPlsOffers: boolean,
    checkmanagedOffers: boolean,
    preferredOfferandNoPreferredOffer: boolean,
    showSelect: boolean,
  };
}

const initialState: CommercialOffersState = {
  data: {
    commercialOffersFound: false,
    existingEcoOffers: false,
    existingCexOffers: false,
    existingCbrOffers: false,
    existingSusOffers: false,
    existingPlsOffers: false,
    checkmanagedOffers: false,
    preferredOfferandNoPreferredOffer: false,
    showSelect: false,
  },
};

export const commercialOffersSlice = createSlice({
  name: 'commercialOffers',
  initialState,
  reducers: {
    existingCommercialOffers: (state, action: PayloadAction<boolean>) => {
      state.data.commercialOffersFound = action.payload;
    },
    existingEcoOffers: (state, action: PayloadAction<boolean>) => {
      state.data.existingEcoOffers = action.payload;
    },
    existingCexOffers: (state, action: PayloadAction<boolean>) => {
      state.data.existingCexOffers = action.payload;
    },
    existingCbrOffers: (state, action: PayloadAction<boolean>) => {
      state.data.existingCbrOffers = action.payload;
    },
    existingSusOffers: (state, action: PayloadAction<boolean>) => {
      state.data.existingSusOffers = action.payload;
    },
    existingPlsOffers: (state, action: PayloadAction<boolean>) => {
      state.data.existingPlsOffers = action.payload;
    },
    checkmanagedOffers: (state, action: PayloadAction<boolean>) => {
      state.data.checkmanagedOffers = action.payload;
    },
    checkpreferredOfferAndNoPreferredOffer: (state, action: PayloadAction<boolean>) => {
      state.data.preferredOfferandNoPreferredOffer = action.payload;
    },
    checkValueShowSelect: (state, action: PayloadAction<boolean>) => {
      state.data.showSelect = action.payload;
    },
  },
});

export const {
  existingCommercialOffers, existingEcoOffers, existingCexOffers,
  existingCbrOffers, existingSusOffers, existingPlsOffers, checkmanagedOffers, checkpreferredOfferAndNoPreferredOffer,
  checkValueShowSelect,
} = commercialOffersSlice.actions;

export default commercialOffersSlice.reducer;
